var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventWpp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    transform: "matrix(-4.37114e-08 1 -1 -1.05524e-06 100 0.279053)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.2791,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#DEFDF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.6696 33.9126C61.5513 29.562 55.9263 27.0759 49.8996 27.0759C37.6451 27.0759 27.6004 37.4345 27.6004 50.0719C27.6004 54.2153 28.7054 58.1516 30.6138 61.5699L27.5 73.4822L39.2522 70.3746C42.567 72.1356 46.183 73.1715 49.8996 73.1715C62.2545 73.1715 72.5 62.8129 72.5 50.1755C72.5 43.9604 69.8884 38.2632 65.6696 33.9126ZM49.8996 69.2352C46.5848 69.2352 43.3705 68.3029 40.4576 66.542L39.8549 66.1276L32.8237 68.0958L34.7321 61.052L34.2299 60.3269C32.4219 57.2193 31.4174 53.6974 31.4174 50.0719C31.4174 39.6098 39.7545 31.0122 50 31.0122C54.9219 31.0122 59.5424 32.9803 63.058 36.6058C66.5737 40.2313 68.683 44.9962 68.683 50.1755C68.683 60.6376 60.1451 69.2352 49.8996 69.2352ZM60.1451 54.9404C59.5424 54.6297 56.8304 53.283 56.3281 53.0759C55.8259 52.8687 55.4241 52.7651 55.0223 53.3866C54.721 53.9046 53.6161 55.2512 53.3147 55.6655C52.9129 55.9763 52.6116 56.0799 52.1094 55.7691C48.7946 54.1117 46.6853 52.7651 44.4754 48.9325C43.8728 47.8966 45.0781 48.0002 46.0826 45.8249C46.2835 45.4106 46.183 45.0998 46.0826 44.789C45.9821 44.4783 44.7768 41.6815 44.375 40.542C43.8728 39.4026 43.471 39.5062 43.0692 39.5062C42.7679 39.5062 42.3661 39.5062 42.0647 39.5062C41.6629 39.5062 41.0603 39.6098 40.558 40.2313C40.0558 40.8528 38.6496 42.1994 38.6496 44.9962C38.6496 47.8966 40.558 50.5898 40.8594 51.0042C41.1607 51.3149 44.7768 57.1157 50.4018 59.6018C53.9174 61.2591 55.3237 61.3627 57.1317 61.052C58.1362 60.9484 60.346 59.7053 60.8482 58.3587C61.3504 57.0121 61.3504 55.8727 61.1495 55.6655C61.0491 55.3548 60.6473 55.2512 60.1451 54.9404Z",
    fill: "#00CBA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventWpp);
export default __webpack_public_path__ + "static/media/canvas_event_wpp.2457672661930e7aeb8a5490bd259b9e.svg";
export { ForwardRef as ReactComponent };